import { render, staticRenderFns } from "./abnormal_user_stat.vue?vue&type=template&id=37e9bb1a&scoped=true&"
import script from "./abnormal_user_stat.vue?vue&type=script&lang=js&"
export * from "./abnormal_user_stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e9bb1a",
  null
  
)

export default component.exports